import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

@Component({
  selector: 'gen-dynamic-width',
  templateUrl: './dynamicWidth.component.html',
  styleUrls: ['dynamicWidth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class DynamicWidthComponent implements OnInit {

  @Input() filter: any;
  @Input() isSelected: any;
  @Input() stat: any;
  indicatorWidth: number;

  constructor() {

  }

  ngOnInit() {
    this.calculateWidth();
  }

  calculateWidth() {
    this.indicatorWidth = Math.round((this.stat.qty / this.filter.statistics.qtyTotal * 133 * 100) / 100);
  }
}
